import React from "react";

export default function TopBar() {
  return (
    <div className="w-full py-4 border-b border-gray-200 bg-white">
      <div className="max-w-6xl mx-auto flex justify-center">
        <a href="https://www.wurq.io/">
          <img
            src="https://cdn.prod.website-files.com/6a12ef0b46874fd425bcc146/6a12fb7937421d3256aa4336_Logo%20wurq.png"
            alt="Wurq Logo"
            className="h-10"
          />
        </a>
      </div>
    </div>
  );
}
